module.exports = __webpack_public_path__ + "media/images/new-ui-images/lab_request-2cca4d2f85484ad7e4e638ddabf719ea.svg";